<template>
  <div class="InvoiceCell mb20">
    <div class="content">
      <div class="top fr ac jsb">
        <p class="fz14">发票类型:{{ info.invoice_type == '1' ? "增值税普票" : "增值票专票" }}</p>
        <div>
          <el-button type="text" @click="updateInvoice" v-if="hasPermission(850)" icon="el-icon-edit-outline">
            编辑
          </el-button>
          <el-button type="text" @click="deleteInvoice" v-if="hasPermission(851)" icon="el-icon-delete">
            删除
          </el-button>
        </div>
      </div>
      <div class="pl20 pt20">
        <p class="fz14 black mb10">发票抬头：{{ info.invoice_name }}</p>
        <p class="fz14 black mb10">统一社会信用代码：{{ info.invoice_taxno }}</p>
        <p
            class="fz14 black mb10"
            v-if="info.invoice_type == '2'"
        >公司地址：{{ info.invoice_address }}</p>
        <p
            class="fz14 black mb10"
            v-if="info.invoice_type == '2'"
        >公司电话：{{ info.invoice_mobile }}</p>
        <p
            class="fz14 black mb10"
            v-if="info.invoice_type == '2'"
        >开户银行：{{ info.invoice_bank_name }}</p>
        <p
            class="fz14 black mb10"
            v-if="info.invoice_type == '2'"
        >银行卡号：{{ info.invoice_back_no }}</p>
      </div>
    </div>
    <div class="mt20" @click.once="setDefault">
      <el-checkbox :value="info.is_default == '1'" :disabled="!hasPermission(852)">默认发票</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object
  },
  data() {
    return {
      checked: true
    };
  },
  methods: {
    setDefault() {
      this.$emit("updateDefaultInvoice", this.info.invoice_id);
    },
    updateInvoice() {
      this.$emit("updateInvoice", this.info);
    },
    deleteInvoice() {
      this.$emit("deleteInvoice", this.info.invoice_id);
    }
  }
};
</script>

<style scoped lang="scss">
.InvoiceCell {
  width: 40%;

  .content {
    width: 100%;
    height: 232px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    box-shadow: 0px 0px 6px rgba(72, 86, 106, 1);
    opacity: 1;

    .top {
      width: 100%;
      height: 45px;
      border-bottom: 1px solid #e5e5e5;
      padding: 0 20px;

      .el-button {
        color: #333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/invoice/InvoiceCell.vue